import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all manufacturers
export const getManufacturer = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/manufacturers`);
    return response.data;
  } catch (error) {
    console.error("Error fetching manufacturers:", error.response?.data || error);
    throw error;
  }
};

// GET a single manufacturer
export const getManufacturerById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/manufacturers/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching manufacturer:", error.response?.data || error);
    throw error;
  }
};

// CHECK if manufacturer exists
export const checkManufacturerExists = async (manufacturer, excludeId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/manufacturers/exists`, {      params: { manufacturer, excludeId },
    });
    return response.data.exists;
  } catch (error) {
    console.error(
      'Error checking manufacturer existence:',
      error.response?.data || error,
    );
    throw error;
  }
};

// CREATE a new manufacturer
export const createManufacturer = async (manufacturerData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/manufacturers`, manufacturerData);
    return response.data;
  } catch (error) {
    console.error("Error creating manufacturer:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing manufacturer
export const updateManufacturer = async (id, manufacturerData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/manufacturers/${id}`, manufacturerData);
    return response.data;
  } catch (error) {
    console.error("Error updating manufacturer:", error.response?.data || error);
    throw error;
  }
};

// DELETE a manufacturer
export const deleteManufacturer = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/manufacturers/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting manufacturer:", error.response?.data || error);
    throw error;
  }
};
